import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthStore } from '@program-suite/data-auth';
import { ProgramTilesComponent } from '@program-suite/ui';
import { getGreeting } from '@program-suite/util-helpers';
import { Router } from '@angular/router';
import { ProgramTile } from '@program-suite/data-common';

@Component({
  selector: 'lib-app-dashboard',
  imports: [CommonModule, ProgramTilesComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  userStore = inject(AuthStore);
  greeting!: string;
  firstName = computed(() => this.userStore.user()?.firstName);

  constructor(private router: Router) {
    this.greeting = getGreeting();
  }

  handleTileSelect(tile: ProgramTile) {
    if (tile.routingUrl) {
      this.router.navigate([tile.routingUrl]);
    }
  }
}
